import React, { ReactElement, ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Icon } from '../../../Icon';
import styles from './index.module.css';

export interface HeaderProps {
  center?: ReactNode;
  title: string;
  left?: ReactNode;
  logoLinkTo?: string;
  right?: ReactNode;
}

export function Header({
  center,
  title,
  logoLinkTo,
  right,
  left,
}: HeaderProps): ReactElement {
  return (
    <header className={classnames('header', styles.root)}>
      <div className="header-panels dbl-padding-left dbl-padding-right">
        <div
          className={classnames('header-panel', {
            [styles.disabledLink]: !logoLinkTo,
          })}
        >
          <Link
            data-testid="header-logo-link"
            to={logoLinkTo || '#'}
            className="header__logo"
          >
            <Icon name="cisco" />
          </Link>
          <div className={classnames('header__title', styles.title)}>
            <Link to={logoLinkTo || '#'} className={styles.link}>
              {title}
            </Link>
            {left}
          </div>
        </div>
        {center && (
          <div className="header-panel header-panel--center">{center}</div>
        )}
        {right && (
          <div className="header-panel header-panel--right">{right}</div>
        )}
      </div>
    </header>
  );
}
